import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../lib/firebase";

/**
 * Consume el customToken depositado en sessionStorage por el admin desde
 * CustomerDetailPanel y firma como el cliente target. Redirige a / al terminar.
 *
 * Diseno: el customToken NO va en la URL para evitar leak en logs/history.
 * Se guarda en sessionStorage (mismo browser tab que lo escribio).
 */
const KEY = "fideliza:impersonate-customer-token";

export function Impersonate() {
  const nav = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = sessionStorage.getItem(KEY);
    if (!token) {
      setError("No hay token de impersonacion. Genera uno desde /admin -> cliente -> 'Ver como cliente'.");
      return;
    }
    sessionStorage.removeItem(KEY); // single-use
    signInWithCustomToken(auth, token)
      .then(() => nav("/", { replace: true }))
      .catch((e) => setError(e.message ?? "Error firmando como cliente."));
  }, [nav]);

  return (
    <main className="grid min-h-dvh place-items-center bg-cream p-6">
      <div className="card max-w-sm text-center">
        {error ? (
          <>
            <p className="font-display text-lg font-semibold text-leaf-950">No pudimos impersonar</p>
            <p className="mt-2 text-sm text-leaf-700">{error}</p>
            <button onClick={() => nav("/platform")} className="btn-primary mt-4">
              Volver a Platform
            </button>
          </>
        ) : (
          <p className="text-sm text-leaf-700">Firmando como cliente…</p>
        )}
      </div>
    </main>
  );
}
